// -- other --
import {useState,useEffect} from "react";
import ImageWithBasePath from "../../../core/img";
import {Link,useNavigate} from "react-router-dom";
import {all_routes} from "../../router/all_routes";
import Slider from "react-slick";
import {Toaster} from 'react-hot-toast';
import series from 'async/series';
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Log,Num,Str,DateTime,Status_Type,Response_Field,Obj,Response_Logic} from "biz9-utility";
import {Message,Config,Type} from "../../../constant";
import {Toast_Message,Image,User,Field_Logic,App,Storage,System} from "../../../project";
import {Data_Logic} from "biz9-data-app";
import {Image_Format} from "biz9-image";
import {User_Table,User_Title,User_Logic,User_Field,User_Role,User_Url,User_Service} from "biz9-user";
import {Portal_Type,Portal_Title,Portal_Url,Page_Logic,Portal_Table,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_User,Portal_Remote_Data,Sub_Value_Type,Portal_Remote_Stat} from "biz9-portal-app";
import {Stat_Logic} from "biz9-stat";

import {Favorite_Service,Favorite_Url} from "biz9-favorite";
import SubValue from "../../subValue";
type PasswordField = "password";
const Login = () => {
    /* -- DEFINE -- *
     * --- IMPORTANT ---
     *  DO NOT CACHE THIS PAGE. On logout and login get sub values which will be removed on log out.
     * --- BUTTONZ ---
     * btn_post_login - post-login
     * --- FIELD-GROUPZ ---
     * #3 thumb
     *    title
     *    sub_note
     *
     */
     // -- main --
    const query = UrlQuery();
    const navigate = useNavigate();

    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
   const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);

    const [val_name,setValName] = useState("Full Name "+Num.get_id());
    const [val_email,setValEmail] = useState("ceo@bossappz.com");
    //const [val_email,setValEmail] = useState("tankrose77@gmail.com");
    const [val_password,setValPassword] = useState("123456789Ab!");
    /*
       const [val_email,setValEmail] = useState("user1@bossappz.com");
       const [val_password,setValPassword] = useState("123456789Ab!");

       const [val_email,setValEmail] = useState("user3@bossappz.com");
       const [val_password,setValPassword] = useState("123456789Ab!");

*/
   useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_page_data();
    },[]);
       async function get_page_data() {
        // -- get-page-remote-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.LOGIN_HOME.title_url,option);
        Log.w('11_response',response);
        Log.w('11_data',data);
        bind_page(data);
    };
   async function bind_page(data) {
        // -- page-template --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
        Toast_Message.dismiss();
    };
    async function bind_sub_values(data_sub_group) {
        // -- bind-sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
     async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }
    async function btn_post_login() {
        // -- post-login --
        Toast_Message.loading(Message.LOADING);
        let option = {login_type:User_Field.EMAIL};
        let user = Data_Logic.get(Portal_Table.USER,0,{data:{email:val_email,password:val_password}});
        let response = Response_Logic.get();
        let data = Data_Logic.get(Portal_Table.USER,0,{data:{role:User_Role.USER}});
        series([
                async function(call) {
                    // -- post-user-login, validate --
                    const [biz_response,biz_data] = await Portal_Remote_User.login(App.get_url(Portal_Url.USER_LOGIN),user);
                    Log.w('33_biz_response',biz_response);
                    Log.w('33_biz_data',biz_data);
                    response = biz_response;
                    data = biz_data;
                    if(response.status == Status_Type.SUCCESS){
                        Toast_Message.success(response.message);
                        Storage.post_dashboard_type_user();
                        User.post(data);
                        if(data.role === User_Role.SUPER_ADMIN){
                            Storage.post_dashboard_apps([System.get_1_app()]);
                        }
                    }else{
                        Toast_Message.error(response.message);
                    }
                },
                async function(call) {
                    // -- post-stat-login --
                    if(response.status == Status_Type.SUCCESS){
                        let stat = Stat_Logic.get(data,Portal_Type.POST_LOGIN,data.id,user);
                        const [biz_response,biz_data] = await Portal_Remote_Stat.post(App.get_url(Portal_Url.STAT_POST),stat);
                        Log.w('11_stat_response',biz_response);
                        Log.w('11_stat_data',biz_data);
                    }
                },
                async function(call) {
                    // -- post-user-appz --
                    if(response.status == Status_Type.SUCCESS && data.role != User_Role.SUPER_ADMIN){
                        let search = Data_Logic.get_search(Portal_Table.APP,{user_id:data.id});
                        const [biz_response,biz_data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_SEARCH),search,option);
                        Storage.post_dashboard_apps(biz_data.items);
                    }
                },
                async function(call) {
                    /*
                    // -- get-user-favorites --
                    if(response.status == Status_Type.SUCCESS && data.role != User_Role.SUPER_ADMIN){
                        //const [biz_response,biz_data] = await Favorite_Service.user_search(App.get_url(Favorite_Url.USER_SEARCH),Portal_Table.PRODUCT,data); --old
                        const url = Remote.get_url(Config.APP_ID,Config.HOST,Portal_Url.DATA_SEARCH);
                        let option = {};
                        let search = Data_Logic.get_search(Portal_Table.BLANK,{});
                        let form_data = {option:option,search:search};
                        const [biz_response,biz_data] = await Remote.post(url,form_data);
                        Storage.post_favorites(biz_data.items);
                    }
                    */
                },
            ],
            function(err, results) {
               if(response.status == Status_Type.SUCCESS && data.role == User_Role.USER){
                    // -- post-user-login --
                    navigate(all_routes.dashboard_user_home);
                }
                else if(data.role == User_Role.ADMIN || data.role == User_Role.SUPER_ADMIN){
                    navigate(all_routes.dashboard_admin_home);
                }
            });
    };
    async function bind_edit() {
        if(query.get('edit_mode')){
            setEditMode(query.get('edit_mode'));
            const handleMessage = (event) => {
                setPage(event.data);
            };
            window.addEventListener('message',handleMessage);
        }
    };

    const updateNameValue = (event: {
target: { value: React.SetStateAction<string> };
}) => {
        setValName(event.target.value);
    };
const updateEmailValue = (event: {
target: { value: React.SetStateAction<string> };
}) => {
    setValEmail(event.target.value);
};
const updatePasswordValue = (event: {
target: { value: React.SetStateAction<string> };
}) => {
    setValPassword(event.target.value);
};
const [passwordVisibility, setPasswordVisibility] = useState({password: false});
const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
                ...prevState,
                [field]: !prevState[field],
                }));
};
const loginslideroption = {
dots: true,
      nav: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      draggable: true,
      tochMove: true,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
return (
        <div>
        <Toaster />
        <>
        {/* Sign In */}
        <div className="row gx-0">
        {/* Banner Content */}
        <div className="col-lg-6">
        <div className="authentication-wrapper">
        <div className="authentication-content">
        <div className="login-carousel">

        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,3):""}
        <Slider {...loginslideroption}>
        {sub_value_group.sub_value_3.items.map((item) => (
                    <div className="login-slider">
                    <ImageWithBasePath
                    src={Image.get_url(item.thumb,Image_Format.ORIGINAL)}
                    className="img-fluid" alt="img" />
                    <h2>
                    {item.title}
                    </h2>
                    <p>
                    {item.sub_note}
                    </p>
                    </div>
                    ))}
        </Slider>
        </div>
        </div>
        <div className="login-bg">
        <ImageWithBasePath
        src="/assets/img/bg/shape-01.png"
        alt="img"
        className="shape-01"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-02.png"
        alt="img"
        className="shape-02"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-03.png"
        alt="img"
        className="shape-03"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-04.png"
        alt="img"
        className="shape-04"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-05.png"
        alt="img"
        className="shape-05"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-06.png"
        alt="img"
        className="shape-06"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-07.png"
        alt="img"
        className="shape-07"
        />
        </div>
        </div>
        </div>
{/* /Banner Content */}

{/* login Content */}
<div className="col-lg-6">
<div className="login-wrapper">
<div className="login-content">
<form>
<div className="login-userset">
<div className="login-logo">
<ImageWithBasePath src="/assets/img/logo.png" alt="img" />
</div>
<div className="login-card">
<div className="login-heading">
<h3>

 {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
    {sub_value_group.sub_value_1.value}

</h3>
<p>

 {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,2):""}
    {sub_value_group.sub_value_2.value}


</p>
</div>
<div>
<label className="form-label">Email</label>
<div className="form-wrap form-focus">
<span className="form-icon">
<i className="feather icon-mail" />
</span>
<input  value={val_email} onChange={updateEmailValue}  type="email" className="form-control floating"/>
</div>
</div>
<div>
<label className="form-label">Password</label>
<div className="form-wrap form-focus pass-group">
<span className="form-icon">
<i
className={`ti toggle-passwords ${passwordVisibility.password
    ? "ti-eye"
        : "ti-eye-off"
}`}
onClick={() =>
    togglePasswordVisibility("password")
}
></i>
</span>

<input  value={val_password}
onChange={updatePasswordValue} type={
    passwordVisibility.password
        ? "text"
        : "password"
}
className="pass-input form-control"
/>

</div>
</div>
<div className="row">
<div className="col-md-6">
<div className="form-wrap">
<div className="form-check">
<input
className="form-check-input"
type="checkbox"
defaultValue=""
id="flexCheckDefault"
/>
<label
className="form-check-label"
htmlFor="flexCheckDefault"
>
Remember Me
</label>
</div>
</div>
</div>
<div className="col-md-6">
<div className="form-wrap text-md-end">
<Link
to={"#"}
className="forgot-link"
>
Forgot Password?
</Link>
</div>
</div>
</div>
<div className="form-wrap mantadory-info d-none">
<p>
<i className="feather icon-alert-triangle" />
Fill all the fields to submit
</p>
</div>
<Link onClick={() => btn_post_login()}  to={"#"} type="submit" className="btn btn-primary">
Sign In
</Link>
{/*
    <div className="login-or">
    <span className="span-or">or sign up with</span>
    </div>

    <ul className="login-social-link">
    <li>
    <Link to="#">
    <ImageWithBasePath
    src="assets/img/icons/google-icon.svg"
    alt="Facebook"
    />{" "}
    Google
    </Link>
    </li>
    <li>
    <Link to="#">
    <ImageWithBasePath src="/assets/img/icons/fb.svg" alt="Google" />{" "}
    Facebook
    </Link>
    </li>
    </ul>
    */}

</div>
<div className="acc-in">
<p>
Don’t have an account?{" "}
<Link to={all_routes.register}>Sign Up</Link>
</p>
</div>
</div>
</form>
</div>
</div>
</div>
{/* /Login Content */}

</div>
{/* /Sign In */}
      <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />

</>
</div>
);
};

export default Login;
